module.exports = __webpack_public_path__ + "img/file_icon.291abf26.svg";